/**
 * Serviço para análise de contas a pagar.
 */

import api from './api'

export const payablesAnalysisService = {
  getAnalysis: async (filters = {}) => {
    const response = await api.get('/api/financial/accounts-payable/analysis', { params: filters })
    return response.data
  }
}
